/* eslint-disable no-unused-vars */
const CaasServerIp = 'http://172.20.130.126'; // Caas platform server
const AlgetaServerIp = 'http://172.20.130.127'; // Algeta core back-end server
const DLBServerIp = 'http://172.20.130.2'; // DLB back-end server
const localServerIp = 'http://127.0.0.1'; // local (for local test)
// local (for local test) - 접속한 주소의 호스트를 그대로 사용 (127.0.0.1 또는 VDI IP 로 다른 사람이 접속)
//const localServerIp = `${window.location.protocol}//${window.location.hostname}`;
const AwsServerIp = 'https://alb.smartlink-platform.com'; // Aws platform server
const AwsDevServerIp = 'https://albdev.smartlink-platform.com'; // Aws platform server

// Only developing application connect to local ip ,another applications connect to developement server ip.
const config = {
  serverIp: `${AwsServerIp}`,
  ReprocessApiUrl: `${AwsServerIp}:3270`,
  monitoringApiUrl: `${AwsServerIp}:3200`,
  dashboardApiUrl: `${AwsServerIp}:3220`,
  dlbApiUrl: `${AwsServerIp}:3150`,
  sessionApiUrl: `${AwsServerIp}:3130`,
  commonApiUrl: `${AwsServerIp}:3140`,
  membershipApiUrl: `${AwsServerIp}:3110`,
  companyApiUrl: `${AwsServerIp}:3120`,
  setupApiUrl: `${AwsServerIp}:3100`,
  integrationsetApiUrl: `${AwsServerIp}:3160`,
  adHelperApiUrl: `${AwsServerIp}:3300`,
  backupApiUrl: `${AwsServerIp}:3240`,
  logTracerApiUrl: `${AwsServerIp}:3210`,
  proxyApiUrl: `${AwsServerIp}:3330`,

  noMenuPages: [
    '/login',
    '/otp',
    '/createaccount',
    '/forgotpassword',
    '/resetpassword',
    '/changedpassword',
    '/changepassword',
  ],
  noSessionCheckPages: [
    '/login',
    '/otp',
    '/createaccount',
    '/forgotpassword',
    '/resetpassword',
    '/changedpassword',
    '/changepassword',
  ],
  noSessionCheckApis: [
    '/membership/login',
    '/membership/otp/',
    '/membership/insert',
    '/membership/change-expired-password',
    '/session/login',
    '/session/refresh',
    '/session/change',
    '/session/info',
    '/session/logout',
    '/forgot-password',
    '/reset-password',
    '/confirm-email',
    '/resend-email',
    '/menu/listCommon',
  ],
  noResponseAlertApis: [
    '/membership/login',
    '/membership/otp/',
    '/membership/insert',
    '/membership/change-expired-password',
    '/session/login',
    '/forgot-password',
    '/reset-password',
    '/confirm-email',
    '/resend-email',
  ],
  embeddedPages: ['/monitoring/token'],
  homePage: '/dashboard', // Move to this page at success login
  provider: 'cyberlogitec.com', // For Super Provider Repository
  dateTimeFormat: 'YYYYMMDD', // Format date time constant for condition search
  tooltipWidth: 300,
  isDlb: false,
  // 2022.3.21 SLI-110 add isAgent flag
  isAgent: true,
  isDlbMybatis: false,
  // 2021.11.8 203728 SPKA-245 move envMode to config
  envServerMode: {
    T: 'test',
    L: 'prod',
  },
};

export default config;
